import styled from "styled-components";

export const Cont = styled.div`
   
  

   #loading, #loading2, #aguarde, #btn-envia-formulario-loading{
    display: none
   }

   input[type="file"] {
    width: 90%;
}
   
   .small, small {
        font-size: 12px;
        font-weight: 400;
        display: block;
    }
    .uk-list>*>ul, .uk-list>:nth-child(n+2){
        margin-top: 0!important;
   }

   .ListaCheckbox {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    gap: 10px;
    div {
        flex-grow: 1;
        width: 25%;
        display: flex;
        flex-direction: row;
        gap: 5px;
        align-items: center;
        @media screen and (max-width: 600px) {
            width: 35%;
        }
        @media screen and (max-width: 400px) {
            width: 100%;
        }
    }
   }
   
  

        @media only screen and  (max-width: 1366px) {

  
        }

        @media only screen and  (max-width: 1024px) {


        }
        @media only screen and  (max-width: 801px) {
            

        }

        @media only screen and  (max-width: 480px) {

        
        }

        @media only screen and  (max-width: 480px) {
        
        }


`;

export const HomeCss = styled.div`

 



`; 